export function getDisplayName(value) {
  return (
    value.display_name ||
    `${value.user.vaxiom_person.first_name} ${value.user.vaxiom_person.last_name}`
  )
}
